import { connect } from 'react-redux';
import {
  canEditMaterials,
  canDeleteMaterials,
  isMaterialRbacEnabled,
  canAccessEducatorArea,
} from '@core/materials/permissions';
import * as classRoomSelectors from '@core/selectors/classroom';
import { getUserPermissionsInCurrentSpace } from '@core/utils/permissions';

import { selectors, operations } from '../../../../../store/materials';
import FolderListItemMenu from './FolderListItemMenu';

const mapStateToProps = (state, ownProps) => {
  const folder = selectors.getMaterial(state, ownProps.materialId) || {};
  return {
    hidden: folder.hidden ?? false,
    scheduledFor: folder.scheduledFor ?? null,
    canEdit: canEditMaterials(state),
    canDelete: canDeleteMaterials(state),
    canAccessEducatorArea: canAccessEducatorArea(state),
    permissions: getUserPermissionsInCurrentSpace(state),
    isStudent: classRoomSelectors.getIsStudent(state),
    isRbacEnabled: isMaterialRbacEnabled(state),
  };
};

const mapsDispatchToProps = (dispatch, ownProps) => ({
  openRenameDialog: () =>
    dispatch(operations.openRenameFolder(ownProps.materialId)),
  openDeleteDialog: () =>
    dispatch(operations.openDeleteFolder(ownProps.materialId)),
  openScheduleDialog: () =>
    dispatch(operations.openScheduleMaterial(ownProps.materialId)),
  keepHidden: () =>
    dispatch(
      operations.editFolder(ownProps.materialId, {
        hidden: true,
        scheduledFor: null,
      })
    ),
  publishNow: () =>
    dispatch(
      operations.editFolder(ownProps.materialId, {
        hidden: false,
        scheduledFor: null,
      })
    ),
});

export default connect(
  mapStateToProps,
  mapsDispatchToProps
)(FolderListItemMenu);
